module.exports = __webpack_public_path__ + "static/gallery10-a5cfd6cacfedaf6d1d8ce837e0deb3be.jpg";